(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { Grid, withStyles } from '@material-ui/core';
var GridColumn = withStyles({
  root: {
    '&.left-column': {
      margin: '10px 10px 10px 0',
      width: '180px'
    },
    '&.right-column': {
      margin: '10 0px 10px 10px',
      width: '180px'
    },
    '& > .MuiFormControl-root': {
      width: '100%'
    }
  }
})(Grid);
var _default = GridColumn;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(GridColumn, "GridColumn", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/lib/GridColumn.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/lib/GridColumn.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();